import { ContextResolver } from '../types';
import opportunitiesBoardResolver from './opportunitiesBoard';
import opportunitiesListResolver from './opportunitiesList';

// Add new view support by appending resolvers to this array.
const userViewContextResolvers: ContextResolver[] = [
    opportunitiesBoardResolver,
    opportunitiesListResolver,
];

export default userViewContextResolvers;
